/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/386-terminal': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 1v14h16V1H0zm15 13H1V2h14v12zM14 3H2v10h12V3zM7 8H6v1H5v1H4V9h1V8h1V7H5V6H4V5h1v1h1v1h1v1zm4 2H8V9h3v1z"/>'
  }
})
